import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';
import { isAPIError } from '@/store/utils';
import type { UpdateParticipantsResponseDTO } from '@/types/SixDetailDTOs';
import type { UpdateManageAccessPayload } from '@/types/manage-access.types';
import { withErrorHandling } from "@/store/thunks/thunkWrappers";
import { fetchParticipantsThunk } from '@/store/thunks/sixDetail/fetchParticipantsThunk';
import { facilitateFileKeys } from '@/store/thunks/fileKey/facilitateFileKeysThunk';

type UpdateCreateSixParticipantsThunkArg = { sixId: string } & UpdateManageAccessPayload;

export const updateCreateSixParticipantsThunk = createAppAsyncThunk<
  UpdateParticipantsResponseDTO,
  UpdateCreateSixParticipantsThunkArg,
  { rejectValue: { message: string } }
>(
  'createSix/updateCreateSixParticipantsThunk',
  withErrorHandling(
  async({ sixId, ...body }: UpdateCreateSixParticipantsThunkArg, { extra, dispatch, rejectWithValue }) => {
    try {
      const response = await extra.sixDetailService.updateSixParticipants(sixId, body);
      await dispatch(fetchParticipantsThunk(sixId));
      await dispatch(facilitateFileKeys());
      return response;
    } catch (error) {
      if (isAPIError(error) || error instanceof Error) {
        return rejectWithValue({ message: error.message });
      }
      throw error;
    }
  }
)
);
